(function (window) {
  'use strict';

  var STORAGE_PREFIX = 'vavara_wishlist_v1_';
  var MAX_ITEMS = 100;

  function storageKey(customerId) {
    return STORAGE_PREFIX + String(customerId || '');
  }

  function read(customerId) {
    if (!customerId) return [];

    try {
      var value = window.localStorage.getItem(storageKey(customerId));
      var items = value ? JSON.parse(value) : [];
      return Array.isArray(items) ? items.filter(function (item) {
        return item && item.id && item.handle;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function write(customerId, items) {
    if (!customerId) return false;

    try {
      window.localStorage.setItem(storageKey(customerId), JSON.stringify(items.slice(0, MAX_ITEMS)));
      document.dispatchEvent(new CustomEvent('vavara:wishlistChanged', {
        detail: { customerId: String(customerId), items: items }
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function normalizeProduct(product) {
    return {
      id: String(product.id),
      handle: String(product.handle || ''),
      title: String(product.title || ''),
      url: String(product.url || ('/products/' + product.handle)),
      image: String(product.image || ''),
      price: Number(product.price || 0),
      compareAtPrice: Number(product.compareAtPrice || 0),
      available: product.available !== false,
      vendor: String(product.vendor || ''),
      addedAt: product.addedAt || new Date().toISOString()
    };
  }

  function forCustomer(customerId) {
    var id = customerId ? String(customerId) : '';

    return {
      key: storageKey(id),
      getItems: function () {
        return read(id);
      },
      has: function (productId) {
        return read(id).some(function (item) {
          return String(item.id) === String(productId);
        });
      },
      add: function (product) {
        var normalized = normalizeProduct(product);
        var items = read(id).filter(function (item) {
          return String(item.id) !== normalized.id;
        });
        items.unshift(normalized);
        write(id, items);
        return true;
      },
      remove: function (productId) {
        var items = read(id).filter(function (item) {
          return String(item.id) !== String(productId);
        });
        write(id, items);
        return false;
      },
      toggle: function (product) {
        if (this.has(product.id)) {
          return this.remove(product.id);
        }
        return this.add(product);
      },
      refresh: function (product) {
        if (!this.has(product.id)) return false;
        var normalized = normalizeProduct(product);
        var items = read(id).map(function (item) {
          if (String(item.id) !== normalized.id) return item;
          normalized.addedAt = item.addedAt || normalized.addedAt;
          return normalized;
        });
        return write(id, items);
      }
    };
  }

  window.VavaraWishlist = {
    forCustomer: forCustomer,
    storagePrefix: STORAGE_PREFIX
  };
})(window);
